<template>
	<div class="container">
		<div v-html="items.body"></div>
	</div>
</template>

<script>
export default {
	props: ["items"]
};
</script>

<style lang="scss"></style>
